import api from '../';

class AlpariGameApi {
    static getItems(params) {
        return api.axios.get('/alpari/items', { params }).then(({ data }) => data);
    }
}

export default AlpariGameApi;
